import type { TourConfig } from '../types';

export const dashboardTour: TourConfig = {
  name: 'dashboard',
  autoStart: true,
  steps: [
    {
      target: '[data-tour="sidebar"]',
      title: 'Navigation Sidebar',
      content:
        'Navigate between different features using the sidebar. Access your Home, Revisions, and more from here.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-greeting"]',
      title: 'Your Workspace',
      content:
        'Switch channels, search projects, or start a new one — all from here.',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-stats"]',
      title: 'Channel at a Glance',
      content:
        'Active videos, pending reviews, drafts scheduled this week, and team size. Tap the Scheduled card to see what is on deck.',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-recent-activity"]',
      title: 'Recent Activity',
      content:
        'Drafts updated most recently across the channel. Open any row to jump straight into the player.',
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-upcoming"]',
      title: 'Upcoming',
      content:
        'Drafts due in the next seven days, sorted by due date. Mark them done or remove them once handled.',
      placement: 'top',
      disableBeacon: true,
    },
  ],
};
